<template>
  <div style="width: 98%; height: 98%; position: relative;">
    <div class="tag-title">
      <el-tag type="warning" style="width: 100%; text-align:center; ">注册会员，扫面二维码领取优惠券</el-tag>
    </div>
    <div  class="tag-title" v-if="s_show">
      <el-select v-model="selectedMoney" placeholder="请选择优惠券金额" @change="couponMoneyChange">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <div id="qrcode" class="image"></div>
    <div class="tag-title">
      <el-alert :title="this.tipInfoAndMoney" type="info" show-icon :closable="false"></el-alert>
    </div>
    <div class="tag-title">
      <el-button type="warning" style="width: 100%;" @click="logout">退出登录</el-button>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2' // 引入qrcode
// import { dateFormat } from '@/utils/utils'
export default {
  created () {

  },
  mounted () {
    // 进入页面，查询客户信息然后生成二维码
    this.queryMerchantInfoAndQr()
  },
  beforeDestroy () {
    // 离开页面之前销毁定时器
    this.destroyTimer()
  },
  data () {
    return {
      options: [],
      selectedMoney: '', // 下拉选择的优惠券金额
      s_show: true, // 下拉框是否显示
      value: '',
      merchantId: '', // 商户ID
      couponMoney: '', // 优惠券金额
      tipInfo: '',
      tipInfoAndMoney: '',
      qrLink: '',
      parkCode: '',
      parkName: '',
      couponUrl: '',
      myTimer: null,
      rechargeDiscount: ''
    }
  },
  methods: {
    // 生成二维码按钮触发函数
    ManualGenqrcode () {
      if (this.qrcode()) {
        // 生成二维码成功，则添加刷新定时器
        this.myTimer = setInterval(this.qrcode, 60000)
      } else {
        this.destroyTimer()
      }
    },

    // 查询客户信息然后生成二维码
    async queryMerchantInfoAndQr () {
      // 发送请求
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') {
        // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      try {
        const { data: res } = await this.$http.get('queryMerchantInfoByToken', {
          headers: { token: token }
        })
        // console.log(res)
        if (res.code === '0') {
        // console.log(JSON.stringify(res.data))
        // 获取信息
          this.merchantId = res.data.merchantId
          this.couponMoney = parseFloat(res.data.couponMoney)
          this.tipInfo = res.data.tipInfo
          // this.tipInfoAndMoney = res.data.tipInfo + ' ' + this.couponMoney + '元'
          this.updateTipInfoAndMoney(res.data.tipInfo, this.couponMoney)
          this.parkCode = res.data.parkCode
          this.parkName = res.data.parkName
          this.couponUrl = res.data.couponUrl
          this.rechargeDiscount = res.data.rechargeDiscount

          // 处理优惠券下拉
          if (res.data.couponMoneyList === '') { // 没有优惠券list
            this.s_show = false
          } else { // 列表
          // 循环加入select优惠券
          // console.log('循环加入select优惠券')
            res.data.couponMoneyList.split(',').map(value => {
              const obj = {}
              obj.value = value
              if (value === '-1' || value === -1) {
                obj.label = '单次免费'
              } else if (value === '-2' || value === -2) {
                obj.label = '时段免费'
              } else {
                obj.label = value + '元优惠券'
              }
              this.options.push(obj)
              if (parseFloat(value) === this.couponMoney) {
                this.selectedMoney = this.couponMoney + ''
              }
            })
          }

          // 生成二维码
          this.qrcode()
          this.myTimer = setInterval(this.qrcode, 15000)
        } else {
          return this.$message.error(res.message)
        }
      } catch (e) {
        this.$message.error('获取失败')
      }
    },

    //  生成二维码通用方法
    async qrcode () {
      // 后台获取二维码内容
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') {
        // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }

      // 优惠券日期
      // const dateStr = dateFormat(new Date())
      // 选择框的优惠券金额不为空
      if (this.selectedMoney) {
        this.couponMoney = this.selectedMoney
      }

      try {
        const { data: res } = await this.$http.get('createCouponlanneng', {
          headers: { token: token, 'Content-Type': 'application/json;charset=utf-8' },
          params: {
            merchantId: this.merchantId,
            couponMoney: parseFloat(this.couponMoney),
            // beginDate: dateStr,
            // endDate: dateStr,
            couponUrl: this.couponUrl,
            parkName: this.parkName,
            parkCode: this.parkCode
          }
        })
        // console.log('优惠券地址：' + res.data)
        if (res.code === '0') {
          this.qrLink = res.data
          this.qrcodejs2()
          return true
        } else {
          this.$message.error(res.message)
          document.getElementById('qrcode').innerHTML = ''
          return false
        }
      } catch (e) {
        this.$message.error('获取失败')
      }
    },

    // 二维码生成方法
    qrcodejs2 () {
      document.getElementById('qrcode').innerHTML = '' // 首先清空二维码内容
      /* eslint-disable no-new */
      new QRCode('qrcode', {
        // 生成二维码
        width: 210,
        height: 210,
        text: this.qrLink // 二维码内容
      })
      // console.log(qrcode)
    },

    // 销毁定时器
    destroyTimer () {
      if (this.myTimer != null) {
        window.clearInterval(this.myTimer)// 出错删除定时器
      }
    },

    // 优惠券选择金额改变事件
    couponMoneyChange () {
      // this.tipInfoAndMoney = this.tipInfo + ' ' + this.selectedMoney + '元'
      this.updateTipInfoAndMoney(this.tipInfo, this.selectedMoney)
      // 手动刷新一下优惠券
      this.qrcode()
    },

    updateTipInfoAndMoney (tipInfo, money) {
      if (money === -1 || money === '-1') {
        this.tipInfoAndMoney = ' 单次免费'
      } else if (money === -2 || money === '-2') {
        this.tipInfoAndMoney = ' 时段免费' + this.rechargeDiscount + '天'
      } else {
        this.tipInfoAndMoney = tipInfo + ' ' + money + '元'
      }
    },

    // 登出
    logout () {
      window.sessionStorage.clear()
      this.$router.push('/login')
    }
  },
  computed: {}
}
</script>

<style lang="less" scoped>
.tag-title {
  position: relative;
  width: 210px;
  margin: 10px auto 0;
  margin-bottom: 20px 0 10px 0;
}
.image {
  position: relative;
  width: 210px;
  height: 210px;
  display: block;
  margin: 10px auto 0;
  padding: 5px;
}
</style>
